import { Box } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { usePrefersReducedMotion } from '../../motion/transitions';

/**
 * Smooth route enter animation — slightly slower for a calmer feel.
 */
export function PageTransition({ children }) {
  const location = useLocation();
  const reduceMotion = usePrefersReducedMotion();

  return (
    <Box
      key={location.pathname}
      sx={{
        width: '100%',
        maxWidth: '100%',
        minWidth: 0,
        overflowX: 'hidden',
        '@keyframes prasaarPageIn': {
          from: {
            opacity: 0,
            transform: reduceMotion ? 'none' : 'translateY(14px)',
          },
          to: {
            opacity: 1,
            transform: 'none',
          },
        },
        animation: reduceMotion
          ? 'prasaarPageIn 160ms ease-out'
          : 'prasaarPageIn 520ms cubic-bezier(0.16, 1, 0.3, 1)',
      }}
    >
      {children}
    </Box>
  );
}
